import { render, staticRenderFns } from "./layout-list.vue?vue&type=template&id=108bee92"
import script from "./layout-list.vue?vue&type=script&lang=js"
export * from "./layout-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src618214693/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('108bee92')) {
      api.createRecord('108bee92', component.options)
    } else {
      api.reload('108bee92', component.options)
    }
    module.hot.accept("./layout-list.vue?vue&type=template&id=108bee92", function () {
      api.rerender('108bee92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout-list.vue"
export default component.exports